import React from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './customQuillStyles.css'; 

const TextEditor = ({ label, placeholder, onChange, inputValue }) => {
    return (
        <div className=''>
            <label className="block text-[14px] font-medium text-gray-700 my-2">{label}</label>
            <ReactQuill
                theme="snow"
                value={inputValue}
                onChange={(val) => onChange(val)}
                
                placeholder={placeholder}
                modules={{
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike', 'blockquote', 'link'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    ],
                }}
                className="px-2 py-3 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 md:text-sm"
            />

        </div>
    )
}

export default TextEditor